module.exports = __webpack_public_path__ + "img/edge_patrimoine_village.4bfc0f39.svg";